/**
 * シフト(2026-09-12)。3つのタブをまとめる画面。
 *  - シフト提出: 本人が「その月のどの日に何時から何時まで入れるか」を出す(ShiftSubmitTab)
 *  - シフト表: 月間の一覧。上段=提出 / 下段=確定(ShiftMonthTab)
 *  - 出勤表: その日の席・割振・時間(AttendanceTab)。現行「シフト表」タブと同じ並び
 * タブは URL(?tab=)に持つので、戻るボタンで戻れる。
 */
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '@core/auth/AuthProvider';
import type { DateStr } from '@core/lib/types';
import AttendanceTab from './AttendanceTab';
import ShiftMonthTab from './ShiftMonthTab';
import ShiftSubmitTab from './ShiftSubmitTab';

type Tab = 'submit' | 'month' | 'attendance';
const TABS: { key: Tab; label: string }[] = [
  { key: 'attendance', label: '出勤表' },
  { key: 'month', label: 'シフト表' },
  { key: 'submit', label: 'シフト提出' },
];

export default function ShiftPage() {
  const { isAdmin } = useAuth();
  const [params, setParams] = useSearchParams();
  const tab = ((params.get('tab') as Tab | null) ?? 'attendance') as Tab;

  const go = (next: Partial<{ tab: Tab; date: DateStr }>) => {
    const p = new URLSearchParams(params);
    if (next.tab) p.set('tab', next.tab);
    if (next.date) p.set('date', next.date);
    setParams(p);
  };

  return (
    <div className="screen master-screen full">
      <div className="toolbar" style={{ marginBottom: 12 }}>
        <div className="tool-filter">
          {TABS.map((t) => (
            <button key={t.key} className={`chip${tab === t.key ? ' on' : ''}`} onClick={() => go({ tab: t.key })}>
              {t.label}
            </button>
          ))}
          {!isAdmin && <span className="hint">出勤表は自分の行だけ表示されます</span>}
        </div>
      </div>

      {tab === 'submit' && <ShiftSubmitTab />}
      {tab === 'month' && <ShiftMonthTab onOpenDate={(d) => go({ tab: 'attendance', date: d })} />}
      {tab === 'attendance' && <AttendanceTab />}
    </div>
  );
}
